import React from 'react';

const RENDER_BLOCK = 5;

export function VirtualList({ containerType="ul", itemSelector="li", items, renderItem, maxHeight, itemHeight=18, ...props }) {
  const [firstBlock, setFirstBlock] = React.useState(0);

  const scrollRef = React.useRef();

  const lineHeight = React.useRef(itemHeight);
  React.useEffect(() => {
    const line = scrollRef.current.querySelector(itemSelector);
    if (line) {
      lineHeight.current = line.offsetHeight;
    }
  }, [items, itemSelector]);

  const onScroll = React.useCallback(() => {
    setFirstBlock(Math.max(Math.floor(scrollRef.current.scrollTop / lineHeight.current / RENDER_BLOCK) - 1, 0));
  }, []);

  const renderFirst = firstBlock * RENDER_BLOCK;
  const renderLast = Math.min(renderFirst + (Math.ceil(maxHeight / lineHeight.current / RENDER_BLOCK) + 4) * RENDER_BLOCK, items.length);
  const visibleItems = items.slice(renderFirst, renderLast);

  const Container = containerType;

  return (
    <div {...props} ref={scrollRef} onScroll={onScroll}>
      <Container style={{marginTop: renderFirst * lineHeight.current, marginBottom: (items.length - renderLast) * lineHeight.current}}>
        {visibleItems.map((item, index) => renderItem(item, index))}
      </Container>
    </div>
  );
}
